export const environment = {
  environmentName: 'dev',
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyCFvm4TSUETAvWQeq5UI1IfgLLXh_DDaY0',
    authDomain: 'cadmus-dev-6ce41.firebaseapp.com',
    projectId: 'cadmus-dev-6ce41',
    storageBucket: 'cadmus-dev-6ce41.firebasestorage.app',
    messagingSenderId: '72975758618',
    appId: '1:72975758618:web:60beaa99cca3c1bc5d68a3',
  },
  useEmulators: false,
  version: 'v0.1.55',

  functionsLinks: {
    pdfEndpoint: 'https://generatepdf-oqigqua73a-ey.a.run.app',
    voucherEndpoint: 'https://generatevoucher-oqigqua73a-ey.a.run.app',
    emailEndpoint: 'https://sendemail-oqigqua73a-ey.a.run.app',
  },
};
